module.exports = __webpack_public_path__ + "static/media/ailing.2b121241.png";